import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DataGridErrorOverlay } from "../../common-ui/DataGridErrorOverlay";

import { PageWrapper, PageWrapperProps } from "../../common-ui/PageWrapper";
import {
  ProgramNetworkErrors,
  ProgramNotifications,
  alphabetizePrograms,
  useAllPrograms
} from "./programUtils";
import { Program } from "../../API";

const pageDetails: PageWrapperProps = {
  className: "Programs",
  headerText: "Programs"
};

export const Programs = ({
  disableVirtualization
}: {
  disableVirtualization?: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { programs, status } = useAllPrograms();

  // Here, they want the programs organized first by Institution name, then by Program name.
  // This is slightly different from the standard alphabetizePrograms features, which just
  // organizes them by Program name.
  let alphabetizedPrograms: Program[] = [];
  if (programs) {
    alphabetizedPrograms = alphabetizePrograms(programs, true);
  }

  const columns: GridColDef[] = [
    {
      headerName: t("Name"),
      field: "name",
      flex: 1
    },
    {
      headerName: t("Description"),
      field: "description",
      flex: 1
    },
    {
      headerName: t("Institution"),
      field: "institutionName",
      valueGetter: (params) => params.row.institution.name,
      flex: 1
    },
    {
      headerName: t("ID"),
      field: "id",
      flex: 1
    }
  ];

  return (
    <PageWrapper {...pageDetails}>
      <div>
        <button onClick={() => navigate(`/programs/new`)}>
          {t("New Program")}
        </button>
      </div>
      <DataGrid
        columns={columns}
        rows={alphabetizedPrograms || []}
        aria-label="programs-table"
        disableVirtualization={disableVirtualization}
        loading={status === "loading"}
        localeText={{
          noRowsLabel: t(ProgramNotifications.NoPrograms)
        }}
        onRowClick={(rowData) => {
          const { row } = rowData;
          const { id } = row;
          if (id) {
            navigate(`${id}`);
          }
        }}
      />
    </PageWrapper>
  );
};
